import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoginPasswordBaseComponent } from 'src/app/open-age/auth/components/login-password-base.component';
import { Organization } from '~/app/open-age/directory/models';
import { environment } from '~/environments/environment';
import { UxService } from '../../../core/services/ux.service';
import { ValidationService } from '../../../core/services/validation.service';
import { RoleService } from '../../../open-age/core/services/role.service';

@Component({
  selector: 'auth-password-login',
  templateUrl: './password-login.component.html',
  styleUrls: ['./password-login.component.css'],
})
export class PasswordLoginComponent extends LoginPasswordBaseComponent {

  @Output()
  forgotPassword: EventEmitter<void> = new EventEmitter();

  options: FormGroup;

  section: 'email' | 'password' = 'email';

  idTypes: string[] = [];

  showPassword = false;

  currentOrganization: Organization;

  constructor(
    auth: RoleService,
    uxService: UxService,
    validationService: ValidationService,
    fb: FormBuilder
  ) {
    super(auth, uxService, validationService);

    this.currentOrganization = auth.currentOrganization();
    auth.organizationChanges.subscribe((i) => this.currentOrganization = i);

    this.options = fb.group({
      hideRequired: false,
      floatLabel: 'auto',
    });

    this.idTypes = environment.loginTypes;

  }

  showForgotPassword() {
    this.forgotPassword.emit();
  }

  labelFor(idType: string) {
    switch (idType) {
      case 'email':
        return 'Email';
      case 'mobile':
        return 'Mobile';
      case 'rollNo':
        return 'Roll No';
      case 'employeeNo':
        return 'Employee No';
    }
  }
}
